import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

/**
 * Both tabs hand the *whole* collection down and filter it in the template
 * (`not-in-archive` / `in-archive`). Filtering here instead would break in two
 * ways documented in docs/ai-blueprints/scan-archiving.md: this hook does not
 * re-run when a scan is archived from elsewhere, and a plain `.filter()` result
 * is not reactive, so a row archived from the list would stay on screen.
 */
class ScansListActiveRoute extends Route {
  model() {
    return this.modelFor('scans.list');
  }
}

export default instrumentRoutePerformance(ScansListActiveRoute);
